import { Field, ErrorMessage } from "formik";

type FormInputProps = {
  type?: string;
  placeholder: string;
  required?: boolean;
  name: string;
};

// Custom error component to handle ARIA attributes
const ErrorMessageComponent = (props: any) => (
  <div className="text-red-500 text-xs font-medium flex mt-2 mb-0" role="alert">
    {props.children}
  </div>
);

const FormInput: React.FC< FormInputProps> = ({ type = "text",
  placeholder,
  required = false,
  name,
 }) => {
  const errorId = `${name}-error`;
  
  return (
    <div className="input-group relative w-full">
      <Field
        type={type}
        name={name}
        className="input text-subtitle-3 font-bold"
        placeholder=" "
        aria-label={placeholder}
        aria-describedby={errorId}
        aria-required={required}
      />
      <label htmlFor={name} className="text-subtitle-5 font-regular">
        {placeholder}
        {required && "*"}
      </label>
      <ErrorMessage
        name={name}
        component={ErrorMessageComponent}
      />
    </div>
  );
};
export default FormInput;